import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.updateLinks();
    this.element.addEventListener("trix-change", this.updateLinks.bind(this));
  }

  updateLinks() {
    this.element.querySelectorAll("a").forEach(link => {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    });
  }
}
